// // Load Images Only Visible On Viewport
// // INTERSECTION OBSERVER
const images = document.querySelectorAll('.lazy-image');
const interactSettings = {
  rootMargin: '0px 0px 200px 0px',
};

function loadImage(lazyImg) {
  const targetElement = lazyImg;
  if (targetElement.tagName === 'SOURCE') {
    targetElement.srcset = targetElement.dataset.srcset;
    targetElement.removeAttribute('data-srcset');
  }
  if (targetElement.tagName === 'IMG') {
    targetElement.src = targetElement.dataset.src;
    targetElement.removeAttribute('data-src');
  }
  if (targetElement.dataset.imgAttachType === 'bgImg') {
    // if (targetElement.dataset.src) {
    //   // eslint-disable-next-line prefer-template
    //   targetElement.style.backgroundImage = 'url(' + targetElement.dataset.src + ')';
    // } else {
    targetElement.classList.add('in-view');
    // }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  if ('IntersectionObserver' in window) {
    // eslint-disable-next-line no-undef
    const observer = new IntersectionObserver((imageEntites) => {
      imageEntites.forEach((image) => {
        if (image.isIntersecting) {
          observer.unobserve(image.target);
          loadImage(image.target);
        }
      });
    }, interactSettings);
    images.forEach((image) => {
      observer.observe(image);
    });
  } else {
    for (let i = 0; i < images.length; i += 1) {
      loadImage(images[i]);
    }
  }
});
